module.exports = __webpack_public_path__ + "static/pink-shape-995dc8a76a4d3813f5424a0afba2b00d.png";